'use client'

import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import { motion } from 'framer-motion'
import { TextCard } from '@/shared/ui/text-card'
import { IInfoCard } from '@/interfaces/common'
import { useAppearance } from '@/shared/utils'
import { variantsHeadline } from '@/shared/constants/variants'
import style from './text-card-list.module.scss'

interface TextCardProps extends HTMLProps<HTMLDivElement> {
  items: IInfoCard[]
}

export const TextCardList = forwardRef<HTMLDivElement, TextCardProps>((props, ref) => {
  const { className, items } = props
  const { ref: innerRef, animate } = useAppearance(ref)

  return (
    <motion.div
      ref={innerRef}
      animate={animate}
      variants={variantsHeadline}
      className={clsx(style.container, className)}
    >
      {items.map((item, index) => {
        return <TextCard className={style.item} key={index} {...item} />
      })}
    </motion.div>
  )
})

TextCardList.displayName = 'TextCardList'
